import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from 'react-router-dom';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function InvResultView(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [invData, setinvData] = useState([]);
    const [ipinvData, setipinvData] = useState([]);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    useEffect(() => {
        fetchData();
        fetchIpData();
    }, [selectedDate]);
    function fetchData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        const url = `${baseUrl}inv-files-view/?start_date=${formattedDate}&end_date=${formattedDate}`;
        axios.get(url)
            .then(response => {
                setinvData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchIpData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        const url1 = `${baseUrl}ip-inv-files-view/?start_date=${formattedDate}&end_date=${formattedDate}`;
        axios.get(url1)
            .then(response => {
                setipinvData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const rows = invData.filter(item => item.itest_id > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date}`,
        appt_id: item.appt_id__appt_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        inv_test: item.appt_id__inv_test,
        addedby: item.addedby,
    }));
    const columns = [
        {field: 'date_time', headerName: 'Date', width: 120},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 170},
        {field: 'inv_test', headerName: 'Particulars', width: 300},
        {field: 'addedby', headerName: 'Addedby', width: 100},
        {
            field: 'view', headerName: 'Action',
            renderCell: (params) => (
                <Link to={`/inv-images/${params.row.id}`} target="_blank" className="btn btn-success">
                    View
                </Link>
            ),
            width: 120
        },
    ];
    const rows1 = ipinvData.filter(item => item.itest_id > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date}`,
        appt_id: item.appt_id__appt_id,
        ip_id: item.ippat_id__ip_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        inv_test: item.appt_id__inv_test,
        addedby: item.addedby,
    }));
    const columns1 = [
        {field: 'date_time', headerName: 'Date', width: 120},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'ip_id', headerName: 'IP Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 170},
        {field: 'inv_test', headerName: 'Particulars', width: 300},
        {field: 'addedby', headerName: 'Addedby', width: 100},
        {
            field: 'view', headerName: 'Action',
            renderCell: (params) => (
                <Link to={`/ip-inv-images/${params.row.id}`} target="_blank" className="btn btn-success">
                    View
                </Link>
            ),
            width: 120
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleStartDateChange}
                                        dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>


            <div style={{height: "100%", width: "100%"}}>
                <h3 className="text-center mt-4" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> View OP Radiology Files</h3>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          rows={rows}
                          columns={columns}
                          pageSize={10}

                          slots={{
                              toolbar: GridToolbar,
                          }}

                          autoHeight
                />
            </div>
            <br></br>
            <div style={{height: "100%", width: "100%"}}>
                <h3 className="text-center mt-4" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> View IP Radiology Files</h3>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          rows={rows1}
                          columns={columns1}
                          pageSize={10}

                          slots={{
                              toolbar: GridToolbar,
                          }}

                          autoHeight
                />
            </div>
        </section>
    )
}
export default InvResultView;
